import styled from 'styled-components';
import Button from "../../../../components/Button/Button.component";
import {accentColorTertiary} from "../../../../assets/styledAssets/vars";

export const StyledButton = styled(Button)`
background-color:${accentColorTertiary}`;
